export default {
  timelinebanners: [],
  pagination: {},
  timelinebanner: {}
}
